import React, { useEffect, useState } from "react";
import { Box, Button, Flex, Text } from "@chakra-ui/react";
import { AnimatePresence, motion } from "framer-motion";
import { Link, useLocation } from "react-router-dom";
import { MenuCloseIcon, HamburgerIcon } from "@/components/Icons";
import { TABS, isTabActive } from "./tabs";

export default function MobileTopBar() {
  const { pathname } = useLocation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    setIsMenuOpen(false);
  }, [pathname]);

  return (
    <Box display={{ base: "block", md: "none" }} w="full" position="relative">
      <Flex bg="primary.200" w="full" align="center" justify="space-between" pr={4}>
        <Button
          variant="plain"
          h="40px"
          px={4}
          py={2}
          gap={2}
          color="grey.1200"
          minW={0}
          onClick={() => setIsMenuOpen((open) => !open)}
        >
          {isMenuOpen ? (
            <MenuCloseIcon w={6} h={6} color="grey.1200" />
          ) : (
            <HamburgerIcon w={6} h={6} />
          )}
          <Text textStyle="body.regular" fontSize="14px" lineHeight="24px" color="grey.1200">
            {isMenuOpen ? "Փակել" : "Մենյու"}
          </Text>
        </Button>

        {/* <Flex align="center" gap={1} py={2}>
          <AmIcon w="25px" h="25px" />
          <Text textStyle="body.regular" fontSize="14px" lineHeight="24px" color="textBlack.800">
            Հայերեն
          </Text>
          <ArrowDownStrokeIcon w={6} h={6} color="textBlack.800" />
        </Flex> TODO::: add language selector */}
      </Flex>

      <AnimatePresence initial={false}>
        {isMenuOpen && (
          <motion.div
            key="topbar-mobile-menu"
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.25, ease: [0.4, 0, 0.2, 1] }}
            style={{
              position: "absolute",
              top: "100%",
              left: 0,
              right: 0,
              zIndex: 20,
              overflow: "hidden",
            }}
          >
            <Flex
              flexDir="column"
              gap={6}
              bg="textBlack.200"
              p={6}
              borderBottomWidth="1px"
              borderBottomColor="textBlack.300"
            >
              {TABS.map(({ label, to }) => {
                const active = isTabActive(pathname, to);
                return (
                  <Box
                    key={to}
                    as={Link}
                    to={to}
                    onClick={() => setIsMenuOpen(false)}
                    className="focus-bordered"
                    borderRadius="2px"
                  >
                    <Text
                      fontSize="20px"
                      lineHeight="32px"
                      fontWeight={600}
                      color={active ? "primary.800" : "textBlack.800"}
                      textDecoration="underline"
                    >
                      {label}
                    </Text>
                  </Box>
                );
              })}
            </Flex>
          </motion.div>
        )}
      </AnimatePresence>
    </Box>
  );
}
